import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../actions/appDataActions';
import * as trackingDataActions from '../actions/trackingDataActions';
import * as appHelper from '../helpers/appHelper';
import {getBiteComponentByType} from '../helpers/componentHelper';


class AppBite extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            bite: this.props.bite,
            bite_type: {}
        };

        this.getBiteType = this.getBiteType.bind(this);
    }
    componentDidMount(){
        //console.log(this.state.md.mobile());
        this.getBiteType();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.bite.bite_id !== nextProps.bite.bite_id){
            this.setState({
                bite: Object.assign({},nextProps.bite),
                bite_type: Object.assign({}, {})
            });
        }

    }

    componentDidUpdate(){
        if(appHelper.isDefined(this.state.bite.bite_id) && !appHelper.isDefined(this.state.bite_type.component)){
            this.getBiteType();
        }
    }

    getBiteType(){
        let biteType = Object.assign({},getBiteComponentByType(this.state.bite.bite_type));
        this.setState({bite_type: Object.assign({},biteType)});
        this.props.actions.clearAudio();
    }

    render() {

        return (
            <div className="app-bite" >
                {
                   typeof this.state.bite_type.component !== 'undefined'
                       ?<this.state.bite_type.component bite={this.state.bite}/>
                       :null
                }
            </div>
        );
    }
}

AppBite.propTypes = {
    bite: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

AppBite.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let bite_id = ownProps.params.bite_id;
    return {
        bite: Object.assign({},appHelper.getBiteById(bite_id))
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps,mapDispatchToProps)(AppBite);



/** WEBPACK FOOTER **
 ** ./src/components/AppBite.js
 **/